import { IconAlertCircle } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'

import { Form } from '@subaio/components/src/HookForm'
import { Partitioned } from '@subaio/webapp'

import type { Step, StepType } from 'containers/Flow/Step'
import type { StepHandlers } from 'containers/Flow/stepHandler'

import { ButtonSolidSubmit } from 'components/Buttons'
import { Card } from 'components/Layout'

import { ButtonGroup } from '../ButtonGroup'
import { Container } from '../Container'
import { InfoBox } from '../InfoBox'
import { Wrapper } from '../Wrapper'

type Props = TaggedType<Step, StepType.Authentication> & {
	onSubmit: StepHandlers['onAuthenticationSubmit']
}

export const Authentication = ({ onSubmit, isLoginInvalid = false }: Props) => (
	<Wrapper>
		<Card>
			<Form<{ code: string }>
				render={() => (
					<>
						<Container>
							<h1>
								<FormattedMessage id='flow.authentication.title' defaultMessage='Get an overview of your finances' />
							</h1>
							<h3>
								<FormattedMessage id='flow.authentication.subtitle' defaultMessage='Enter your password' />
							</h3>
							<Partitioned label='' name='code' type='number' isRequired />
							{isLoginInvalid && (
								<InfoBox type='danger'>
									<IconAlertCircle />
									<FormattedMessage
										id='flow.authentication.invalid'
										defaultMessage='The link and/or code is invalid. If the issue persists, reach out to your advisor.'
									/>
								</InfoBox>
							)}
							<p>
								<FormattedMessage
									id='flow.authentication.description'
									defaultMessage='Thank you for helping us understand your financial situation so we can offer you the best options.'
								/>
							</p>
							<p>
								<FormattedMessage
									id='flow.authentication.description2'
									defaultMessage='It typically takes 5-10 minutes to complete the process.'
								/>
							</p>
						</Container>
						<ButtonGroup>
							<ButtonSolidSubmit
								label={<FormattedMessage id='flow.authentication.buttonSubmit' defaultMessage='Start' />}
							/>
						</ButtonGroup>
					</>
				)}
				onSubmit={(fields) => onSubmit(fields.code)}
			/>
		</Card>
	</Wrapper>
)
